import { gsap } from "gsap";
import { Flip } from "gsap/flip";

gsap.registerPlugin(Flip);

class Filter {
  constructor($el) {
    this.$el = $el;
    this.el = this.$el[0];
    this.$buttons = this.$el.find(".filter__object");
    this.$grid = $("[data-filter-grid]");
    this.$items = this.$grid.find(".reference-item");
    this.queryKey = "filter";

    if (!this.$el.length || !this.$buttons.length || !this.$items.length)
      return;

    this.init();
  }

  init = () => {
    this.$buttons.on("click", this.onFilterClick);
    document.addEventListener("click", this.onDocumentClick);
    window.addEventListener("popstate", this.syncFromUrl);
    this.syncFromUrl(false);
  };

  onFilterClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const $button = $(event.currentTarget);
    const filterValue = ($button.attr("data-filter") || "").trim();
    const currentFilter = this.getCurrentFilter();

    if (currentFilter === filterValue) {
      this.setFilter(null);
    } else {
      this.setFilter(filterValue);
    }
  };

  onDocumentClick = (event) => {
    if (!this.el) return;
    if (this.el.contains(event.target)) return;

    if (this.getCurrentFilter()) {
      this.setFilter(null);
    }
  };

  getCurrentFilter = () => {
    const params = new URLSearchParams(window.location.search);
    const value = params.get(this.queryKey);
    return value ? value.trim() : null;
  };

  setFilter = (filterValue) => {
    const url = new URL(window.location.href);

    if (filterValue) {
      url.searchParams.set(this.queryKey, filterValue);
    } else {
      url.searchParams.delete(this.queryKey);
    }

    window.history.pushState({}, "", url.toString());
    this.syncFromUrl(true);
  };

  syncFromUrl = (animate) => {
    const currentFilter = this.getCurrentFilter();

    this.$buttons.removeClass("is-active");

    const state = animate ? Flip.getState(this.$items.toArray()) : null;

    if (!currentFilter) {
      this.$items.removeClass("is-hidden");
    } else {
      const $activeButton = this.$buttons.filter((_, el) => {
        return ($(el).attr("data-filter") || "").trim() === currentFilter;
      });

      if ($activeButton.length) {
        $activeButton.addClass("is-active");
      }

      this.$items.each((_, item) => {
        const $item = $(item);
        const categories = ($item.attr("data-category") || "")
          .trim()
          .split(/\s+/)
          .filter(Boolean);

        $item.toggleClass("is-hidden", !categories.includes(currentFilter));
      });
    }

    if (animate && state) {
      Flip.from(state, {
        duration: 0.45,
        ease: "power2.inOut",
        stagger: 0.02,
        absolute: false,
        scale: false,
        onEnter: (elements) => {
          gsap.fromTo(
            elements,
            { opacity: 0, y: 12 },
            { opacity: 1, y: 0, duration: 0.3, ease: "power2.out" },
          );
        },
        onLeave: (elements) => {
          gsap.to(elements, {
            opacity: 0,
            y: 12,
            duration: 0.22,
            ease: "power2.in",
          });
        },
      });
    }
  };
}

export default Filter;
